import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({
  color = defaultIconColor,
  size = defaultSize,
  outlined = false,
  ...props
}: SVGComponentPropsType) => (
  <svg
    width={size}
    height={size}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M4.6666 4c0-.5523.4477-1 1-1h7c.5523 0 1 .4477 1 1v17h-9V4Z"
      stroke={color}
      strokeWidth="2"
    />
    <path d="M1.6666 21h15" stroke={color} strokeWidth="2" />
    <path
      d="M4.6666 10h9.9902c1.1084 0 2.0054.9014 2 2.0098l-.019 3.8802c-.0084 1.7151 1.3797 3.11 3.0948 3.11v0c2.0041 0 3.4797-1.8757 3.0079-3.8234l-1.0865-4.4853V6.537L17.3111 2"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path d="M18.6666 3v8h3" stroke={color} strokeWidth="2" strokeLinejoin="round" />
  </svg>
);
